var _classCallCheck = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Btc = require("@ledgerhq/hw-app-btc").default;

var util = require("../../util");

var _require$TierError = require("@oneledger/middle_utility").TierError,
    ErrorType = _require$TierError.ErrorType,
    ErrorUtil = _require$TierError.ErrorUtil;

var requestErrors = ErrorType.requestErrors;
var btcAddrBasePath = {
  legacy: "m/44'/0'/0'/0/",
  p2sh: "m/49'/0'/0'/0/",
  bech32: "m/173'/0'/0'/0/"
};
/**
 * LedgerHQ Bitcoin wallet
 */

var Bitcoin =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * @description init btc wallet
   * @param transport {Object} transport object
   * Web version of transport needs to get from oneledger/ledger-sdk-web repo https://github.com/Oneledger/ledger-sdk-web
   * Node version of transport needs to get from oneledger/ledger-sdk-node repo https://github.com/Oneledger/ledger-sdk-node
   */
  function Bitcoin(transport) {
    _classCallCheck(this, Bitcoin);

    try {
      this.btc = new Btc(transport);
    } catch (err) {
      throw Error("failed to establish the connection to the BitCoin wallet");
    }
  }
  /**
   * @description fetch btc address with public key
   * @param keyIndex {number} non-negative integer
   * @param verify {boolean} whether ask user to confirm the address on the device, default is true
   * @param format {string} address format, "legacy" | "p2sh" | "bech32", default is "legacy"
   */


  _createClass(Bitcoin, [{
    key: "getAddrPubKey",
    value: function getAddrPubKey(keyIndex) {
      var verify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "legacy";
      if (!format in btcAddrBasePath) return Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidBitcoinAddressFormatLedgerHQ));
      if (!Number.isInteger(keyIndex) || Number(keyIndex) < 0) return Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidKeyIndex));
      return this.btc.getWalletPublicKey(btcAddrBasePath[format] + keyIndex, {
        verify: verify,
        format: format
      }).then(function (response) {
        var bitcoinAddress = response.bitcoinAddress,
            publicKey = response.publicKey,
            chainCode = response.chainCode;
        return Promise.resolve(ErrorUtil.responseWrap({
          address: bitcoinAddress,
          publicKey: publicKey
        }));
      }).catch(function (err) {
        if (err.statusCode === 27010) err.message = "wallet application is not opened";
        if (err.statusCode === 27904) err.message = "wallet does not match the request";
        var returnErr = requestErrors.FailToGetBitcoinAddrLedgerHQ;
        returnErr.detail = "failed to get btc address: ".concat(err.message);
        return Promise.reject(ErrorUtil.errorWrap(returnErr));
      });
    }
    /**
     * @description sign btc tx
     * @param keyIndex {number} non-negative integer
     * @param rawTxHex {string} hexed raw tx with 0x prefix
     * @param format {string} address format, "legacy" | "p2sh" | "bech32", default is "legacy"
     */

  }, {
    key: "signTransaction",
    value: function signTransaction(keyIndex, rawTxHex) {
      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "legacy";
      if (!format in btcAddrBasePath) return Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidBitcoinAddressFormatLedgerHQ));
      if (!Number.isInteger(keyIndex) || Number(keyIndex) < 0) return Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidKeyIndex));
      if (!util.isValidString(rawTxHex) || !rawTxHex.startsWith("0x")) return Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidBTCRawTxLedgerHQ));
      return this.btc.signMessageNew(btcAddrBasePath[format] + keyIndex, rawTxHex.substr(2)).then(function (response) {
        var s = response.s,
            v = response.v,
            r = response.r;
        var vd = v + 27 + 4;
        var signature = Buffer.from(vd.toString(16) + r + s, 'hex').toString('base64');
        return Promise.resolve(ErrorUtil.responseWrap({
          signature: signature
        }));
      }).catch(function (err) {
        if (err.statusCode === 27904) err.message = "wallet does not match the request";
        var returnErr = requestErrors.FailedToSignBTCTxLedgerHQ;
        returnErr.detail = "failed to sign btc tx: ".concat(err.message);
        return Promise.reject(ErrorUtil.errorWrap(returnErr));
      });
    }
  }]);

  return Bitcoin;
}();

module.exports = {
  Bitcoin: Bitcoin
};